<template>
  <!-- 订单详情价格信息 -->
  <div class="det_price">
    <div class="order_id font12 font_weight500 line_height_17 text_left">
      <div class="title_text">商品总额</div>
      <div class="value_text">
        {{ getUserOrder.orderMoney | currency(false) }}
      </div>
    </div>
    <div class="order_id font12 font_weight500 line_height_17 text_left">
      <div class="title_text">税率费用</div>
      <div class="value_text">
        {{ getUserOrder.taxMoney | currency(false) }}
      </div>
    </div>
    <div class="order_id font12 font_weight500 line_height_17 text_left">
      <div class="title_text">运费</div>
      <div v-if="getUserOrder.freightMoney" class="value_text">
        {{ getUserOrder.freightMoney | currency(false) }}
      </div>
      <div v-else class="value_text">免运费</div>
    </div>
    <div
      v-if="getUserOrder.discountMoney"
      class="order_id font12 font_weight500 line_height_17 text_left"
    >
      <div class="title_text">优惠金额</div>
      <div class="value_text">
        -{{ getUserOrder.discountMoney | currency(false) }}
      </div>
    </div>
    <div
      v-if="getUserOrder.deductionProfit && getUserOrder.deductionProfit > 0"
      class="order_id font12 font_weight500 line_height_17 text_left"
    >
      <div class="title_text">抵扣佣金</div>
      <div class="value_text">
        -{{ getUserOrder.deductionProfit | currency(false) }}
      </div>
    </div>
    <div class="order_total font16 line_height_22 text_left">
      <div class="colo087 font_weight500">应付金额</div>
      <div class="font_weight600 total_price">
        {{ getUserOrder.total | currency(false) }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  }
};
</script>

<style lang="less" scoped>
.det_price {
  background: #fff;
  margin: 12px 0 68px 0;
  padding: 18px 12px;
  .order_id {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-bottom: 12px;
    .title_text {
      color: rgba(0, 0, 0, 0.65);
    }
    .value_text {
      color: #333;
    }
  }
  .order_total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 6px;
    padding-bottom: 6px;
    .total_price {
      color: #f23030;
      font-size: 16px;
    }
  }
}
</style>
